<template>
  <div class="account-page">
    <div class="account-content">
      <div class="login-wrapper bg-img d-flex">
        <!-- Form Section -->
        <div class="login-content d-flex justify-content- align-items-center flex-column position-relative h-screen"
          style="height: 100vh;">
          <Form @submit="onSubmit" :validation-schema="schema" class="mt-5" v-slot="{ errors }">
            <div class="d-flex justify-content-center mb-4">
              <img src="@/assets/img/nedam_mouhassib.png" class="mb-5" width="40%" alt="">
            </div>
            <div class="login-userset">
              <div class="login-userheading">
              </div>
              <div class="form-login mt-8">
                <label class="form-label">Adresse Email</label>
                <div class="form-addons">
                  <Field name="email" type="text" value="admin@example.com" class="form-control"
                    :class="{ 'is-invalid': errors.email }" />

                  <img v-if="!errors.email" src="@/assets/img/icons/mail.svg" alt="img" />

                  <!-- Error message -->
                  <div class="invalid-feedback">{{ errors.email }}</div>
                  <div class="emailshow text-danger" id="email"></div>
                </div>
              </div>
              <div class="form-login">
                <label>Mot de Passe</label>
                <div class="pass-group">
                  <Field name="password" :type="showPassword ? 'text' : 'password'" value="password123"
                    class="form-control pass-input mt-2" :class="{ 'is-invalid': errors.password }" />

                  <!-- Show eye/eye-slash icon only if no password error -->
                  <span v-if="!errors.password" @click="toggleShow" class="toggle-password">
                    <i :class="{
                      'fas fa-eye': showPassword,
                      'fas fa-eye-slash': !showPassword,
                    }"></i>
                  </span>

                  <!-- Error message -->
                  <div class="invalid-feedback">{{ errors.password }}</div>
                  <div class="emailshow text-danger" id="password"></div>
                </div>
              </div>
              <div class="form-login">
                <button class="btn btn-login" type="submit">Se connecter</button>
              </div>

              <!-- Additional text under the button -->
              <div class="additional-info mt-4">
                <p class="text-center fw-bold mb-3">Utiliser votre compte pour accéder à la plateforme.
                </p>
                <p class="text-center text-muted">En cas de difficulté, veuillez contacter l'administrateur.</p>
              </div>
            </div>
            <footer class="text-center text-xs text-gray-400 fw-bold">
              <br />
              Tous droits réservés © {{ yearRange }},
              <a href="https://eryx.ma" target="_blank" class="fw-bolder hover:underline">Eryx.ma</a>
            </footer>
          </Form>
        </div>

        <!-- Side Image Section with overlay text and enhanced shadow -->
        <div
          class="side-image-section position-relative d-flex align-items-center justify-content-center text-white shadow-lg">
          <img src="@/assets/img/image.jpg" alt="Login Image" class="side-image" />
          <!-- Dark overlay for better text readability -->
          <div class="image-overlay"></div>
          <div class="position-absolute text-center px-4 z-index-2">
            <h3 class="fw-bold text-white mb-4">
              GÉREZ VOS CLIENTS ET CONTRATS EN TOUTE SIMPLICITÉ
            </h3>
            <p class="mt-4 fs-6 fw-light">
              Une Solution intelligente, centralisée et conforme pour vos projets professionnels.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<style scoped>
/* Only adding minimal styles for the side image layout */
.login-wrapper {
  min-height: 100vh;
}

.side-image-section {
  flex: 1;
  min-height: 100vh;
}

.side-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
}

.login-content {
  flex: 1;
  padding: 2rem;
}

/* Enhanced image overlay for better text readability */
.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg,
      rgba(0, 0, 0, 0.6) 0%,
      rgba(0, 0, 0, 0.4) 50%,
      rgba(0, 0, 0, 0.7) 100%);
  z-index: 1;
}

/* Enhanced text shadow effect */
.text-shadow {
  text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.7);
}

.text-shadow-strong {
  text-shadow:
    2px 2px 4px rgba(0, 0, 0, 0.8),
    1px 1px 2px rgba(0, 0, 0, 0.9);
}

/* Z-index to ensure text appears above overlay */
.z-index-2 {
  z-index: 2;
}

/* Styling for additional info section */
.additional-info h3 {
  font-size: 1.1rem;
  color: #333;
  line-height: 1.4;
}

.additional-info h4 {
  font-size: 1rem;
  color: #6c757d;
  font-weight: normal;
  line-height: 1.3;
}

/* Responsive - stack vertically on mobile */
@media (max-width: 768px) {
  .login-wrapper {
    flex-direction: column;
  }

  .side-image-section {
    flex: none;
    height: 200px;
  }

  .login-content {
    flex: 1;
    min-height: calc(100vh - 200px);
  }

  /* Adjust text size on mobile */
  .additional-info h3 {
    font-size: 1rem;
  }

  .additional-info h4 {
    font-size: 0.9rem;
  }
}
</style>

<script>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import * as Yup from "yup";
import axios from "axios";
import { Form, Field } from "vee-validate";

export default {
  components: {
    Form,
    Field,
  },
  data() {
    return {
      showPassword: false,
      emailError: "",
      passwordError: "",
      startYear: 2023,
      currentYear: new Date().getFullYear(),
    };
  },
  computed: {
    yearRange() {
      return `${this.currentYear}`;
    },
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
  },
  setup() {
    const router = useRouter();

    const schema = Yup.object().shape({
      email: Yup.string()
        .required("Email is required")
        .email("Email is invalid"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
    });

    const onSubmit = async (values) => {
      document.getElementById("email").innerHTML = "";
      document.getElementById("password").innerHTML = "";

      try {
        const response = await axios.post("/login", {
          email: values.email,
          password: values.password,
        });

        if (response.data.access_token) {
          localStorage.setItem("access_token", response.data.access_token);
          let user = {
            username: response?.data?.user?.name,
            role: response?.data?.user?.is_admin === 1 ? "admin" : "user",
            email: response?.data?.user?.email,
          };

          const expiresAt = response.data.expires_at;
          localStorage.setItem("expires_at", expiresAt);
          localStorage.setItem("user", JSON.stringify(user));
          
          router.push("/dashboard");
        } else {
          document.getElementById("email").innerHTML =
            "Login failed. Unexpected response.";
        }
      } catch (error) {
        const res = error.response;
        if (res?.status === 422) {
          const errors = res.data.message;
          if (errors) {
            document.getElementById("email").innerHTML = errors.email[0];
          }
        } else if (res?.status === 401 || res?.status === 400) {
          document.getElementById("email").innerHTML =
            res.data.message || "Invalid login credentials";
        } else {
          document.getElementById("email").innerHTML =
            "Login failed. Please try again later.";
          console.error("Login error:", error);
        }
      }
    };

    onMounted(() => {
      const token = localStorage.getItem("access_token");
      if (token) {
        router.push("/dashboard");
      }
    });

    return {
      schema,
      onSubmit,
      checked: ref(false),
    };
  },
};
</script>